import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Spinner } from 'app/components/common';
import { Translate } from '../../../../services';

import './styles.less';

export const LoadingPopup = ( props ) => {
    const [ isHidden, setHidden ] = useState( false );

    // Construct the classes to use for the root component.
    const classes = classnames(
        'loading-popup',
        { 'visible': props.visible },
        { 'hiding': !props.visible && !isHidden },
        { [ props.className ]: Boolean( props.className ) },
    );

    useEffect( () => {
        if ( !props.visible && !isHidden ) {
            setTimeout( () => setHidden( true ), 200 );
        }
    }, [ props.visible, isHidden, setHidden ] );

    // If the component should be fully hidden, don't render anything.
    if ( !props.visible && isHidden ) {
        return <></>;
    }

    return (
        <div className="loading-popup-container">
            <div className={ classes }>
                <div className="loading-popup-visuals">
                    <img className="glasses-frame" src="/images/loading-glasses-frame-01.svg" alt="Glasses frame" />
                    <Spinner className="loading-popup-eye-spinner-left" />
                    <Spinner className="loading-popup-eye-spinner-right" />
                </div>
                
                <div className="loading-popup-visuals-seiko">
                    <Spinner />
                </div> 

                <div className="loading-popup-text">
                    <Translate.Text value="popup.loadingEllipsis" />
                </div>
            </div>
        </div>
    );
};

LoadingPopup.defaultProps = {
    className: undefined,
    visible: true,
};

LoadingPopup.propTypes = {
    className: PropTypes.string,
    visible: PropTypes.bool,
};
